/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignPipelineStageInputDataSchema = z.object({
	name: z.string(),
	id: z.string().nullable().optional(),
	locked: z.boolean().nullable().optional(),
})

export type CampaignPipelineStageInputDataSchema = z.infer<typeof campaignPipelineStageInputDataSchema>
